import {
  Box,
  Container,
  Typography,
  Stack,
  Link,
  Collapse,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useState } from "react";
import { contactsDetails } from "../../data/ContactsData";

export default function FooterDetails() {
  const [openServices, setOpenServices] = useState(false);

  return (
    <Box sx={{ bgcolor: "#233529", color: "white", py: 6 }}>
      <Container>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={5}
          justifyContent="space-between"
        >
          {/* Contact Info */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
              Contact Info
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Phone: {contactsDetails.phone}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Email: {contactsDetails.email}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Address: {contactsDetails.location}
            </Typography>
            <Typography variant="body2">
              Postal Code: {contactsDetails.postalCode}
            </Typography>
          </Box>

          {/* Social Media */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
              Social Media
            </Typography>

            <div className="contact-right">
              <FacebookIcon className="social-icon" />
              <XIcon className="social-icon" />
              <InstagramIcon className="social-icon" />
            </div>
          </Box>

          {/* Quick Links */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
              Quick Links
            </Typography>

            <Stack spacing={1}>
              <Link href="/" underline="hover" sx={{ color: "white" }}>
                Home
              </Link>
              <Box
                onClick={() => setOpenServices(!openServices)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  color: "white",
                  gap: 1, // small gap between text and icon
                }}
              >
                <Typography variant="body1">Services</Typography>
                {openServices ? (
                  <ExpandLessIcon fontSize="small" />
                ) : (
                  <ExpandMoreIcon fontSize="small" />
                )}
              </Box>
              <Collapse in={openServices} timeout="auto" unmountOnExit>
                <Stack spacing={1} sx={{ pl: 2, mt: 1 }}>
                  <Link
                    href="/services/planning"
                    underline="hover"
                    sx={{ color: "white" }}
                  >
                    House Planning & Design
                  </Link>
                  <Link
                    href="/services/approval"
                    underline="hover"
                    sx={{ color: "white" }}
                  >
                    Plan Approval
                  </Link>
                  <Link
                    href="/services/interior"
                    underline="hover"
                    sx={{ color: "white" }}
                  >
                    Interior
                  </Link>
                </Stack>
              </Collapse>
              <Link href="/packages" underline="hover" sx={{ color: "white" }}>
                Packages
              </Link>
              {/* <Link href="/projects" underline="hover" sx={{ color: "white" }}>
                Projects
              </Link> */}
              <Link href="/contact" underline="hover" sx={{ color: "white" }}>
                Contact Us
              </Link>
            </Stack>
          </Box>

          {/* About Us */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
              About Us
            </Typography>

            <Typography variant="body2" sx={{ lineHeight: 1.7 }}>
              VR Builders & Promoters is a leading construction company
              delivering high-quality residential and commercial building
              projects for over 10 years across Tamil Nadu. We focus on quality,
              trust, and timely delivery.
            </Typography>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
